import { render, staticRenderFns } from "./NavPaginator.vue?vue&type=template&id=79ca14c0&"
import script from "./NavPaginator.vue?vue&type=script&lang=js&"
export * from "./NavPaginator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports